var YT,ytPlayer,hasYoutube;
function onYouTubeIframeAPIReady() {
	campaign.init();
}
var campaign = {
	init: function(){
		if(isPage === "special"){
			ytMovie.id = $(".nav_movie li a.active").attr("data-id");
			ytMovie.init();
		}
	}
}
var ytMovie = {
	id: "",
	total: 0,
	state: 0,
	canPlay: false,
	isPlaying: false,
	init: function(){
		let playerID = $("#ytPlayer")[0];
		this.nav();
		ytPlayer = new YT.Player(playerID, {
			videoId 	: ytMovie.id,
			playerVars 	: {
				autohide	: 1,
				controls	: 1,
				frameborder : 0,
				rel			: 0,
				start		: 0,
				showinfo 	: 0,
				disablekb	: 1,
				wmode		: "transparent",
				autoplay	: 0,
				mute 		: 0,
				playsinline	: 1,
				enablejsapi	: 1,
				iv_load_policy: 3,
				origin: location.protocol + '//' + location.hostname + "/"
			},
			events : {
				onReady: function(e){
					hasYoutube  	= true;
					ytPlayer 		= e.target;
					ytMovie.canPlay = true;
				},
				onStateChange: function(e){
					if(e.data === 1){
						ytMovie.isPlaying = true;
						ytMovie.state = 1;
					}
				},
				onError: function(e){
					var errorstatus = e.data;
				}
			}
		});
	},
	nav: function(){
		$(".nav_movie li a").off().on("click", function(){
			$(".nav_movie li a").removeClass("active");
			$(this).addClass("active");
			ytMovie.id = $(this).attr("data-id");
			ytPlayer.loadVideoById(ytMovie.id);
		});
	}
}